/* eslint-disable camelcase */
import { SORT_ORDER, TFilterOptions } from '@evinced-private/ui-common';

import omit from 'lodash-es/omit';
import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';
import {
	ConditionOperators,
	Wfa_Session_RunsSortFields,
	Wfa_Session_RunsSortOrder,
	Wfa_Session_RunsTextSearchFields
} from 'src/common/types/graphql.generated';
import { ITableQueryParams } from 'src/common/types/TableQueryTypes';

import { WfaSessionsQueryVariables } from '../WfaSessions.generated';

const DAYS_AMOUNT_FILTER_PARAM_KEY = 'daysAmountFilter';
const CREATED_BY_FILTER_PARAM_KEY = 'createdByFilter';
const CUSTOM_FIELDS_FILTER_PARAM_KEY = 'customFieldsFilter';

const sessionsTextSearchFields: Wfa_Session_RunsTextSearchFields[] = [
	Wfa_Session_RunsTextSearchFields.SessionName,
	Wfa_Session_RunsTextSearchFields.RunTime,
	Wfa_Session_RunsTextSearchFields.CriticalIssues,
	Wfa_Session_RunsTextSearchFields.TotalIssues,
	Wfa_Session_RunsTextSearchFields.UserName
];

const sessionsSortFieldNamesMap: Record<string, Wfa_Session_RunsSortFields> = {
	sessionName: Wfa_Session_RunsSortFields.SessionName,
	runTime: Wfa_Session_RunsSortFields.RunTime,
	criticalIssues: Wfa_Session_RunsSortFields.CriticalIssues,
	totalIssues: Wfa_Session_RunsSortFields.TotalIssues,
	createdBy: Wfa_Session_RunsSortFields.UserName
};

const sessionsSortOrderMap: Record<SORT_ORDER, Wfa_Session_RunsSortOrder> = {
	[SORT_ORDER.ASC]: Wfa_Session_RunsSortOrder.Ascending,
	[SORT_ORDER.DESC]: Wfa_Session_RunsSortOrder.Descending
};

export const buildSessionsQueryVariables = ({
	pageSize,
	page,
	sort,
	filterOptions
}: ITableQueryParams): WfaSessionsQueryVariables => {
	const variablesBuilder = new QueryVariablesBuilder<WfaSessionsQueryVariables>({
		sortFieldsMap: sessionsSortFieldNamesMap,
		sortOrderMap: sessionsSortOrderMap,
		searchFields: sessionsTextSearchFields
	});

	// omit all the know filter keys.
	// this will leave us with the dynamic filter keys - the ones configured in the CC for labels
	const dynamicFilterOptions = omit<TFilterOptions>(filterOptions ?? {}, [
		'createdBy',
		'sessionsPeriod',
		'searchValue'
	]);

	variablesBuilder
		.addPaginationParams(page, pageSize)
		.addSortParam(sort)
		.addTextSearchParam(filterOptions?.searchValue ?? '')
		.addFilterParam(CREATED_BY_FILTER_PARAM_KEY, filterOptions?.createdBy)
		.addTupleFilterParam(
			CUSTOM_FIELDS_FILTER_PARAM_KEY,
			dynamicFilterOptions,
			ConditionOperators.All
		);

	const selectedPeriod = filterOptions?.sessionsPeriod?.[0];
	if (selectedPeriod && selectedPeriod.value !== 'all') {
		variablesBuilder.addFilterParam(DAYS_AMOUNT_FILTER_PARAM_KEY, filterOptions?.sessionsPeriod);
	}

	return variablesBuilder.getVariables();
};
